import fieldUtils from "../../utils/step.fields.utils.js";
import config from "../../config.js";
import products from "../../utils/products.js";

const medicalConditions = (n) => {
    const result = [
        {...fieldUtils.medical_condition_x_type(n)},
    ];

    if (n < config[products.travel].medical_conditions) {
        result.push({
            ...fieldUtils.medical_condition_x_more(n),
            children: medicalConditions(n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};

const travellers = (n) => {
    const fields = [
        {...fieldUtils.traveller_x_name(n)},
        {...fieldUtils.traveller_x_date_of_birth(n)},
    ]

    if (n < config[products.travel].travellers) {
        fields.push({
            ...fieldUtils.traveller_x_more(n),
            label: 'Are any additional travellers required on the policy?',
            children: travellers(n + 1),
            required_children: value => value === true,
        });
    }
    return fields;
}
const step_schema_travel = [
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone'
    },
    {
        key: 'email'
    },
    {
        key: 'date_of_birth'
    },
    {
        key: 'postcode'
    },
    {
        key: 'address1',
        skip_question: true,
    },
    {
        key: 'address2',
        skip_question: true,
    },
    {
        key: 'address3',
        skip_question: true,
    },
    {
        key: 'address4',
        skip_question: true,
    },
    {
        key: 'city',
        skip_question: true,
    },
    {
        key: 'has_medical_conditions',
        children: medicalConditions(0),
        required_children: value => value === true,
    },
    {
        key: 'has_another_traveller_more',
        label: 'Are any additional travellers required on the policy?',
        children: travellers(0),
        required_children: value => value === true
    },
    //policy
    {
        key: 'travel_type'
    },
    {
        key: 'destination'
    },
    {
        key: 'travel_estimated_time'
    },
    {
        key: 'hazardous_activities'
    },
    {
        key: 'cover_duration',
        options: []
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
];
export default step_schema_travel;
